import { Box } from '@mui/material';

import { RouterManager } from '@router/RouterManager';

export const App = () => {
  return (
    <Box sx={{ minHeight: '100vh', px: { xs: 1, sm: 2 } }}>
      <RouterManager />
    </Box>
  );
};
